var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1921 0.285824C20.121 0.112864 19.9533 4.33592e-05 19.7673 0C1.93076 0 0 7.43883 0 10.6374C0 14.787 3.14072 17.5749 7.81496 17.5749C13.7185 17.5749 14.9551 11.9232 15.6189 8.88642C16.2642 5.79526 17.8234 2.97262 20.0918 0.789007C20.2232 0.657022 20.2627 0.458523 20.1921 0.285824Z",
    fill: "#2DB875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.459719 20.3505C0.205833 20.3505 0 20.1435 0 19.888C0 17.138 4.73954 8.31446 12.2116 4.67186C12.4401 4.56051 12.715 4.65655 12.8258 4.88644C12.9364 5.11633 12.841 5.39297 12.6125 5.50436C5.06686 9.18308 0.919395 17.7264 0.919395 19.8881C0.919395 20.1435 0.713605 20.3505 0.459719 20.3505Z",
    fill: "#3CD58B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.882a444b9f6806d401bbd04729611d38.svg";
export { ForwardRef as ReactComponent };